import { Link } from "@mui/material";

export const MobileIntegrityChecks = () => {
  return <div>
    <Link href="/mobile">Back</Link>
    Just kidding!
  </div>;
};
